import React, { useState, useEffect, useMemo } from "react";

import { TimelineLane, TimelineName } from "./";

export function TimelineSlot({
  timeline,
  chronicle,
  currentDate,
  timelineCalendar,
  granularity,
  units,
  containerRef,
}) {
  const [timelineLanes, setTimelineLanes] = useState(null);
  // console.group("Timeline Slot Render");
  // console.log('Props', currentDate, granularity, units);
  useEffect(() => {
    // console.log('Calculating Timelanes!');
    let lanes = [];
    for (let l = 0; l < 4; l++) {
      lanes.push(
        <TimelineLane
          laneID={l}
          key={l}
          timelineID={timeline._id}
          chronicle={chronicle}
          currentDate={currentDate}
          calendar={timelineCalendar}
          granularity={granularity}
          containerRef={containerRef}
        />
      );
    }
    // console.log('Lanes', lanes);
    setTimelineLanes(lanes);
  }, [timeline, chronicle, currentDate, timelineCalendar, units, granularity]);
  // console.groupEnd();

  const handleDefaultContextMenu = (ev) => {
    ev.preventDefault();
  };

  return (
    <div
      className="chronos-timeline-slot"
      onContextMenu={handleDefaultContextMenu}
    >
      {timelineLanes}
      <TimelineName timeline={timeline} />
    </div>
  );
}
